import { MenuSeparator } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

import { AccordionItem, AccordionItemContent, AccordionItemTrigger, AccordionRoot } from '@/components/ui/accordion'
import { Box } from '@/components/ui/box'
import useColorModeValue from '@/hooks/useColorModeValue'

import HelpCenterList from '../menuList/HelpCenterList'

const HelpCenterMobileVersion = () => {
    const { t } = useTranslation()
    const accordionTextValue = t('global.helpCenter.menu.groupTitle')
    return (
        <Box display={['block', 'block', 'block', 'none']}>
            <AccordionRoot multiple border="none" pb="0">
                <AccordionItem border="none" pl="0" value={accordionTextValue}>
                    <AccordionItemTrigger p="0" _hover={{ backgroundColor: 'transparent' }}>
                        <Box
                            as="span"
                            flex="1"
                            textAlign="left"
                            ml="12px"
                            fontSize="12px"
                            color={useColorModeValue('rgba(84, 79, 64, 0.7)', 'rgba(255, 255, 255, 0.7)')}
                        >
                            {accordionTextValue}
                        </Box>
                    </AccordionItemTrigger>
                    <AccordionItemContent pl="0" pb="0" pt="0">
                        <HelpCenterList />
                    </AccordionItemContent>
                </AccordionItem>
            </AccordionRoot>
            <MenuSeparator />
        </Box>
    )
}

export default HelpCenterMobileVersion
